
import { mapActions } from "vuex";
import { ADMIN_ACCOUNT_CREATED } from "@/constants/MixpanelEvents.js";
import CountrycodeWithTextfield from "../common/countrycode-with-textfield.vue";
import logo from "~/assets/images/logo.png";

export default {
  components: { CountrycodeWithTextfield },
  name: "userLogin",
  props: {
    tab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      logo,
      profile: {
        name: "",
        email: "",

        mobile: {
          country_code: "+91",
          number: ""
        },
        password: ""
      },
      showPassword: false,
      loading: false,
      valid: false,
      isPhoneValid: false,
      formError: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => /^.{6,}$/.test(v) || "Sorry! Your password is too short"
      ]
    };
  },
  watch: {},
  computed: {
    isFormValid() {
      if (this.tab === 0) {
        return this.valid && this.isPhoneValid;
      } else {
        return this.valid;
      }
    }
  },
  methods: {
    ...mapActions("auth", ["signup"]),

    validateForm() {
      this.valid = this.$refs.form.validate();
    },
    getTermsOfSerivceUrl() {
      return window.location.origin;
    },
    handleClick() {
      this.$emit("switch-page");
    },

    submitSignup() {
      this.validateForm();
      if (this.valid) {
        this.loading = true;
        var $ls = this.$ls;
        const payload = {
          platform: "web",
          name: this.profile.name,
          password: this.profile.password,
          password_confirmation: this.profile.password
        };
        if (this.tab === 0) {
          payload.mobile_number =
            this.profile.mobile.country_code + this.profile.mobile.number;
        } else {
          payload.email = this.profile.email;
        }
        this.signup(payload)
          .then((response) => {
            if (response.data.status === "success") {
              this.mixPanelTrackEvent(ADMIN_ACCOUNT_CREATED, {
                profile: this.profile
              });

              this.$emit(
                "switch-to-signup-otp-verification",
                this.profile,
                response
              );
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
